/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
// @ts-ignore
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import { isBrowser } from '../../utils';

interface ISeo {
  description?: string;
  lang?: string;
  title?: string;
  meta?: any[];
}

const SEO: React.FC<ISeo> = ({
  description,
  lang = 'sr',
  meta = [],
  title,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: 'keywords',
          content: 'blog, travel, food, svetlana, milikic',
        },
        {
          name: 'author',
          content: site.siteMetadata.author,
        },
        {
          name: 'robots',
          content: 'follow, index',
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <link
        href="https://fonts.googleapis.com/css?family=Libre+Caslon+Display|Open+Sans:300,300i,400,600,700&display=swap"
        rel="stylesheet"
      />
      <link
        rel="canonical"
        href={`${site.siteMetadata.siteUrl}${isBrowser && location.pathname}`}
      />
    </Helmet>
  );
};

export default SEO;
